import { BooleanFormType } from "Store/interfaces/FormTypes";
import { booleanToFormBoolean } from "Utils/formUtils";
import { isDefined } from "Utils/functions";
import { AdviceProductDetailsBackendValues } from "../../../Advice/ProductDetails/FormElements/interfaces";
import { ChildProductIntroFormValues } from "./childProductIntroInterfaces";

export const mapChildAdviceToForm = (
  adviceProductValues: AdviceProductDetailsBackendValues | undefined,
): Partial<ChildProductIntroFormValues> => {
  if (!isDefined(adviceProductValues)) {
    return {
      isScandinavianCitizen: undefined,
      isStayingInNorwayForMoreThanFiveYears: undefined,
      pep: undefined,
    };
  }

  const inNorway = adviceProductValues.isStayingInNorwayForMoreThanFiveYears;

  if (isDefined(inNorway)) {
    return {
      isScandinavianCitizen: BooleanFormType.FALSE,
      isStayingInNorwayForMoreThanFiveYears: booleanToFormBoolean(inNorway),
      pep: BooleanFormType.FALSE,
    };
  }
  return {
    isScandinavianCitizen: BooleanFormType.TRUE,
    pep: BooleanFormType.FALSE,
  };
};
